import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Injectable } from '@angular/core';
import { TaskPerformanceService } from './task-performance.service';
import * as ObjectActions from './task-performance.actions';
import * as oeeAppReducer from '../../oee.reducer';
import { Store } from '@ngrx/store';
import { switchMap, catchError } from 'rxjs/operators';
import * as AppActions from '../../app/actions';
import { of } from 'rxjs';
import {
  ITaskPerformanceData,
} from './task-performance.model';
import { GetManyResponseInterface } from '../../../shared/model/interface/crud-response-interface.model';
import { emptyAction } from '../../../../constants';
import { HelperService } from '../../../shared/service/helper.service';
import { CodeAndNameDisplayService } from '../../../shared/service/code-and-name-display/code-and-name-display.service';

@Injectable()
export class TaskPerformanceEffects {
  constructor(
    private readonly codeAndNameDisplayService: CodeAndNameDisplayService,
    private readonly actions$: Actions,
    private readonly store: Store<oeeAppReducer.OeeAppState>,
    public service: TaskPerformanceService,
    public readonly helperService: HelperService,
  ) {}

  getTaskPerformanceData = createEffect(() =>
    this.actions$.pipe(
      ofType(ObjectActions.TASK_PERFORMANCE_DATA_LOADING),
      switchMap((objectData: ObjectActions.TaskPerformanceDataLoading) => {
        this.store.dispatch(new AppActions.ShowLoader());

        return this.service.getTaskPerformanceData(objectData.params).pipe(
          switchMap((response: GetManyResponseInterface<ITaskPerformanceData>) => {
            const formattedData: ITaskPerformanceData[] = response.data.map((row: ITaskPerformanceData) => {
              return {
                ...row,
                activityName: this.codeAndNameDisplayService.getDisplay({
                  name: row.activityName,
                  code: row.activityCode,
                }),
                taskName: this.codeAndNameDisplayService.getDisplay({ name: row.taskName, code: row.taskCode }),
                phaseName: this.service.getPhaseNames(row),
              };
            });
            return of(new ObjectActions.TaskPerformanceDataLoaded(formattedData), new AppActions.HideLoader());
          }),
          catchError((err: any) => {
            return of(new ObjectActions.FetchDataError(err), new AppActions.HideLoader());
          }),
        );
      }),
      catchError((err) => {
        return of(new ObjectActions.FetchDataError(err), new AppActions.HideLoader());
      }),
    ),
  );

  taskPerformanceDownloadExcel = createEffect(() =>
    this.actions$.pipe(
      ofType(ObjectActions.TASK_PERFORMANCE_DOWNLOAD_EXCEL),
      switchMap((objectData: ObjectActions.TaskPerformanceDownloadExcel) => {
        this.store.dispatch(new AppActions.ShowLoader());
        this.service.downloadExcel(
          HelperService.cloneDeep(objectData.worksheetsColumnDefinitions),
          objectData.excelData,
        );

        return emptyAction;
      }),
      catchError((err) => {
        return of(new ObjectActions.FetchDataError(err), new AppActions.HideLoader());
      }),
    ),
  );
}
